const EXCLUDED_CORE_ADDON_HOSTS = new Set([
    'v3-channels.strem.io',
    'caching.stremio.net',
]);

const isExcludedCoreAddon = (addonOrUrl) => {
    const value = typeof addonOrUrl === 'string' ? addonOrUrl : addonOrUrl?.transportUrl;
    if (typeof value !== 'string') return false;
    try {
        const url = new URL(value);
        const path = url.pathname.replace(/\/+$/, '');
        return (url.hostname === 'v3-channels.strem.io' && path === '/manifest.json') ||
            (url.hostname === 'caching.stremio.net' && path === '/publicdomainmovies.now.sh/manifest.json');
    } catch (_) {
        return false;
    }
};

const planManagedAddons = (approvedUrls, disabledUrls, trackedUrls, installedAddons) => {
    const approved = new Set(approvedUrls.filter((url) => !isExcludedCoreAddon(url)));
    const disabled = new Set(disabledUrls);
    const tracked = new Set(trackedUrls);
    const installed = new Set(installedAddons.map((addon) => addon.transportUrl));
    const removeCandidates = new Set([...tracked, ...disabled]);
    installedAddons.filter(isExcludedCoreAddon).forEach((addon) => removeCandidates.add(addon.transportUrl));

    return {
        remove: [...removeCandidates].filter((url) =>
            (!approved.has(url) || disabled.has(url)) && installed.has(url)),
        install: [...approved].filter((url) => !installed.has(url)),
        keepTracked: [...tracked].filter((url) => approved.has(url)),
    };
};

module.exports = { isExcludedCoreAddon, planManagedAddons };
